import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { LayoutContext } from 'contexts/LayoutContext';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { CancelCardStackParamList } from './type';
import moment from 'moment-timezone';
import { CardCancelReasonFilters } from '../../options';

export interface CancelCardProps {
  onClose: () => void;
  data: any;
  onLayout: (event: any) => void;
  account: string;
  tab?: number;
  returnData?: any;
  refresh?: () => void;
}

export const CancelCardWebTwoScreen: React.FC<CancelCardProps> = (props) => {
  const { onClose, data, onLayout, account, tab, returnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const layout = useContext(LayoutContext);
  const {
    topHeader,
    body,
    horizontalWrapper,
    textLabel,
    textDebitAmount,
    textTitle,
    textAtmPin,
    btn,
    textHeaderTitle,
    textHeaderSubTitle
  } = sxStyles;

  const navigation = useNavigation<NativeStackNavigationProp<CancelCardStackParamList>>();

  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View
      sx={{
        height: layout.isMobile ? '100%' : 'auto',
        width: layout.dimensions.width,
        maxWidth: layout.isMobile ? layout.dimensions.width : Math.min(500, layout.dimensions.width),
        backgroundColor: '$backgroundPrimary'
      }}
      onLayout={(event) => {
        onLayout(event);
      }}>
      <View sx={topHeader}>
        <Icon name="checkCircleBlue" height={108} width={108} />
        <H6 bold sx={textHeaderTitle}>
          {t('credit-card-cancel-card::cancel-card-placed.title--cancel-card-placed')}
        </H6>
        <TextCaption sx={textHeaderSubTitle}>{t('credit-card-cancel-card::cancel-card-placed.text--you-have-cancelled')}</TextCaption>
      </View>
      <View sx={body}>
        <View>
          <TextCaption sx={textTitle} semiBold>
            {t('credit-card-cancel-card::glossary.reason')}
          </TextCaption>
          <H6 sx={textAtmPin}>{CardCancelReasonFilters(t).find((el) => el.value === data.reason)?.label}</H6>
        </View>
        <View sx={horizontalWrapper}>
          <TextBody sx={textLabel}>{t('credit-card-cancel-card::glossary.instruction-time')}</TextBody>
          <TextBody sx={textDebitAmount}>{returnData?.instructionTime || instructionTime || '-'}</TextBody>
        </View>
        <UniButton
          sx={btn}
          labelSx={{ color: '$balck' }}
          label={t('card-account-management::general.button--close')}
          onPress={() => {
            refresh();
            navigation.getParent()?.goBack();
          }}
        />
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault',
    mt: '$10'
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28,
    gap: '$5'
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  btn: {
    width: '100%',
    height: 44
  },
  textHeaderTitle: {
    mb: '$2'
  },
  textHeaderSubTitle: {
    color: '$textPrimary'
  }
};
